import {useEffect} from 'react';

const ENTER_KEY = 'Enter';
const SPACE_KEY = ' ';

const listener = (e: KeyboardEvent) => {
    const focusedElement = document.activeElement;
    if (
            !focusedElement ||
            !focusedElement.hasAttribute('tabindex') ||
            focusedElement.getAttribute('tabindex') === '-1' ||
            ['a', 'button', 'input', 'select', 'textarea'].includes(focusedElement.tagName.toLowerCase()) ||
            ![ENTER_KEY, SPACE_KEY].includes(e.key)
    ) {
        return;
    }

    const event = new MouseEvent('click', {
        bubbles: true,
    });

    focusedElement.dispatchEvent(event);
};

function SyntheticInteractiveElementsKeyboardEventsProvider(props: { children: any }) {
    useEffect(() => {
        addEventListener('keyup', listener);

        return () => {
            removeEventListener('keyup', listener);
        };
    });

    return props.children;
}

export default (SyntheticInteractiveElementsKeyboardEventsProvider);
